import React from 'react';
import { withRouter } from 'react-router';
import DropDownMaker from './subcomponents/DropDownMaker';
import styles from '../statics/styles';
import '../statics/stylesheet.css';
import Tabs from 'material-ui/Tabs';
import Tab from 'material-ui/Tabs/Tab';

const getObjectValue = (arr) => {
  const tempArray = [];
  for (let i = 0; i < arr.length; i++) {
    tempArray.push(arr[i]);
  }
  return tempArray;
};

class SizeSelection extends React.Component {

  constructor(props) {
    if (JSON.parse(localStorage.getItem('feedForFilter'))) {
      localStorage.removeItem('feedForFilter');
    }
    super(props);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.dropDownRef = null;
    this.state = {
      loading: false,
      staggeredSearch: false,
      checked: true
    };
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyPress);
    window.scrollTo(0, 0);
  }

  getSizes() {
    const data = require('../utils/tiresize.json');
    if (this.state.tire_size_dropdown) {
      return;
    } 
    const treadWidthsData = getObjectValue(data.tread_widths);
    const wheelProfilesData = getObjectValue(data.wheel_profiles);
    const wheelSizesData = getObjectValue(data.wheel_sizes);
    this.setState({ loading: false, treadWidths: treadWidthsData, wheelProfiles: wheelProfilesData, wheelSizes: wheelSizesData });
  }

  fromStyle() {
    if (this.props.inSizes) {
      return 'content-inSizesStyle';
    }
    return 'content-divLength';
  }

  componentWillMount() {
    document.removeEventListener("keydown", this.handleKeyPress);
    this.getSizes();
    this.setState({ style: this.fromStyle() });
    if (window.sessionStorage.getItem('staggered') == 'true') {this.setState({ staggeredSearch: true });}
  }

  handleKeyPress(event) {
    if (event.key === "Enter") {
      this.triggerSubmit();
    }
  }

  triggerSubmit() {
    if (this.dropDownRef && this.dropDownRef.props.whenClicked) {
      const options = {
        tread_width: this.dropDownRef.state.tread_width,
        wheel_profile: this.dropDownRef.state.wheel_profile,
        wheel_size: this.dropDownRef.state.wheel_size,
      };

      this.dropDownRef.props.whenClicked(options);
    }
  }

  TabPanel = (props) => {
    const { children, value, index } = props;
    if (!this.state.value) {
      this.state.value = 0;
    }
    return (
			<div
				role="tabpanel"
				id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
       			>
				{value === index && <div>{children}</div>}
			</div>
    );
  };

  a11yProps = (index) => {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
      style: { background: 'white', Width: '33%' }
    };
  };

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };

  render() {
    const { router } = this.context;
    const { loading, staggeredSearch } = this.state;
    const { category, search_by } = this.props.params;
    const { treadWidth, wheelProfile, wheelSize } = this.state;

    window.localStorage.removeItem('performance tire');

    return (
      <div className={this.state.style}>

        {navigator.userAgent.toLowerCase().indexOf('chrome') > -1 || navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ?
          loading &&
          <div className="sizeSelection-loading">
            <img src={window.host + '/statics/img/loading.svg'} />
          </div> :
          loading &&
          <div className="sizeSelection-loading">
            <img src={window.host + '/statics/img/loading.gif'} />
          </div>
        }

        <div className="sizeSelection-sizeContainer">
          <h2 className="content-titleFont">Search {category.toUpperCase()} by size: </h2>
          <div style={{ textAlign: ' center' }}>
          </div>

          <div className="sizeSelection-sizeContainer-wheels-desktop">
          <Tabs
							value={this.state.value}
              onChange={this.handleChange}
              className="jss110"
							indicatorColor="primary"
							textColor="primary"
              aria-label="full width tabs example"
              centered="true"
						>
              <Tab label="&#10003; non-Staggered Search " {...this.a11yProps(0)} className={this.state.value === 0 ? 'jafar' : 'gholi'} style={{ color: '#c50000', boxShadow: this.state.value === 0 ? '0 2px 8px rgba(197, 0, 0, 0.3)' : 'inset 0 0px 0 0 #ffffff, inset 0 -1px 0 0 rgba(204, 204, 204, 0.3)' }}/>
              <Tab label=" &#9881; Staggered Search" {...this.a11yProps(1)} className={this.state.value === 1 ? 'jafar' : 'gholi'} style={{ color: '#c50000', boxShadow: this.state.value === 1 ? '0 2px 8px rgba(197, 0, 0, 0.3)' : 'inset 0 0px 0 0 #ffffff, inset 0 -1px 0 0 rgba(204, 204, 204, 0.3)', marginLeft: '3px' }}/>
              <Tab label=" &#128269; Quick Search" {...this.a11yProps(2)} className={this.state.value === 2 ? 'jafar' : 'gholi'} style={{ color: '#c50000', boxShadow: this.state.value === 2 ? '0 2px 8px rgba(197, 0, 0, 0.3)' : 'inset 0 0px 0 0 #ffffff, inset 0 -1px 0 0 rgba(204, 204, 204, 0.3)', marginLeft: '3px' }}/>
						</Tabs>
          </div>

          <div className="sizeSelection-sizeContainer-wheels-mobile">
          <Tabs
							value={this.state.value}
              onChange={this.handleChange}
              className="jss110"
							indicatorColor="primary"
							textColor="primary"
              aria-label="full width tabs example"
              centered="true"
						>
              <Tab label="&#10003; non-Staggered" {...this.a11yProps(0)} className={this.state.value === 0 ? 'jafar' : 'gholi'} style={{ color: '#c50000', boxShadow: 'inset 0 0px 0 0 #ffffff, inset 0 -1px 0 0 rgba(204, 204, 204, 0.3)' }}/>
              <Tab label=" &#9881; Staggered" {...this.a11yProps(1)} className={this.state.value === 1 ? 'jafar' : 'gholi'} style={{ color: '#c50000', boxShadow: 'inset 0 0px 0 0 #ffffff, inset 0 -1px 0 0 rgba(204, 204, 204, 0.3)', marginLeft: '3px' }}/>
              <Tab label=" &#128270; Quick" {...this.a11yProps(2)} className={this.state.value === 2 ? 'jafar' : 'gholi'} style={{ color: '#c50000', boxShadow: 'inset 0 0px 0 0 #ffffff, inset 0 -1px 0 0 rgba(204, 204, 204, 0.3)', marginLeft: '3px' }}/>
						</Tabs>
          </div>

 <this.TabPanel value={this.state.value} index={0} style={{ border: '1px red' }}>
   <br/>
    <DropDownMaker
              buttonlist={[
                { id: 'tread_width', name: 'Tread Width', options: this.state.treadWidths },
                { id: 'wheel_profile', name: 'Tire Profile', options: this.state.wheelProfiles },
                { id: 'wheel_size', name: 'Wheel Size', options: this.state.wheelSizes }
              ]}
              btnStyle={styles.shoppingMethodButtonWithMargin}
              sizeFilled={
                window.sessionStorage.getItem('treadWidth') !== null &&
                window.sessionStorage.getItem('tireProfile') !== null &&
                window.sessionStorage.getItem('wheelSizes') !== null
              }
              submitButton={{
                name: 'Go!',
                classname: 'btn btn-primary',
                disabled: !(this.state.selectedTreadWidth && this.state.selectedWheelProfile && this.state.selectedWheelSize)
              }}
              whenClicked={(options) => {
                let missingFields = [];
              
                if (!options.tread_width) {
                  missingFields.push('Tread Width');
                }
                if (!options.wheel_profile) {
                  missingFields.push('Tire Profile');
                }
                if (!options.wheel_size) {
                  missingFields.push('Wheel Size');
                }
                if (missingFields.length > 0) {
                  alert('Please select the following: ' + missingFields.join(', '));
                } else {
                  this.goToURL(category, search_by, options.tread_width, options.wheel_profile, options.wheel_size, router);
                }
              }}
    />
</this.TabPanel>

<this.TabPanel value={this.state.value} index={1} style={{ border: '1px red' }}>
<br/>
<DropDownMaker
            buttonlist={[
              { id: 'tread_width_front', name: 'Tread Width Front', options: this.state.treadWidths },
              { id: 'wheel_profile_front', name: 'Tire Profile Front', options: this.state.wheelProfiles },
              { id: 'wheel_size_front', name: 'Wheel Size Front', options: this.state.wheelSizes },
              { type: 'separator' },
              { id: 'tread_width_rear', name: 'Tread Width Rear', options: this.state.treadWidths },
              { id: 'wheel_profile_rear', name: 'Tire Profile Rear', options: this.state.wheelProfiles },
              { id: 'wheel_size_rear', name: 'Wheel Size Rear', options: this.state.wheelSizes }
            ]}
            btnStyle={styles.shoppingMethodButtonWithMargin}
            submitButton={{ name: 'Go!', classname: 'btn btn-primary' }}

            whenClicked={(options) => {
              let missingFields = [];
            
              if (!options.tread_width_front) {
                missingFields.push('Tread Width Front');
              }
              if (!options.wheel_profile_front) {
                missingFields.push('Tire Profile Front');
              }
              if (!options.wheel_size_front) {
                missingFields.push('Wheel Size Front');
              }
              if (!options.tread_width_rear) {
                missingFields.push('Tread Width Rear');
              }
              if (!options.wheel_profile_rear) {
                missingFields.push('Tire Profile Rear');
              }
              if (!options.wheel_size_rear) {
                missingFields.push('Wheel Size Rear');
              }
              if (missingFields.length > 0) {
                alert('Please select the following: ' + missingFields.join(', '));
              } else {
                this.goToStaggeredURL(
                  category, 
                  search_by, 
                  options.tread_width_front, 
                  options.wheel_profile_front, 
                  options.wheel_size_front, 
                  options.tread_width_rear, 
                  options.wheel_profile_rear,
                  options.wheel_size_rear, 
                  router
                );
              }
            }}
          />
</this.TabPanel>

<this.TabPanel value={this.state.value} index={2} style={{ border: '1px red' }}>
  <br/>
  <DropDownMaker
    ref={(ref) => (this.dropDownRef = ref)}
    buttonlist={[
      { id: "all_params", name: "Quick Search (ie. 2056016)" },
    ]}
    btnStyle={styles.shoppingMethodButtonWithMargin}
    sizeFilled={window.sessionStorage.getItem('treadWidth') !== null && window.sessionStorage.getItem('tireProfile') && window.sessionStorage.getItem('wheelSizes')}
    submitButton={{ name: "Go!", classname: "btn btn-primary" }}
    whenClicked={(options) => {
      if (options.staggeredQuickSearch && options.tread_width_rear && options.wheel_profile_rear && options.wheel_size_rear) {
        this.goToStaggeredURL(
          category,
          search_by,
          options.tread_width,
          options.wheel_profile,
          options.wheel_size,
          options.tread_width_rear,
          options.wheel_profile_rear,
          options.wheel_size_rear,
          router
        );
      } else {
        this.goToURL(
          category,
          search_by,
          options.tread_width,
          options.wheel_profile,
          options.wheel_size,
          router
        );
      }
    }}
  />
</this.TabPanel>

        </div>
      </div>
    );
  }

  goToURL(category, searchBy, treadwidth, wheelprofile, wheelsize, router) {

    const selectedSeasonsUrl = JSON.parse(localStorage.getItem('selected_tire_seasons') || '["all"]');
    
    if (this.props.inSizes) {
      const vehicle = this.props.params.options.split(' ').join('%20');
      router.push('/' + category.replace(/ /g, '%20') + '/' + searchBy + '/' + vehicle + '/' + treadwidth + '-' + wheelprofile + '-' + wheelsize + '?season=' + selectedSeasonsUrl[0]);
    } else {
      router.push('/' + category.replace(/ /g, '%20') + '/Size/' + treadwidth + '-' + wheelprofile + '-' + wheelsize + '?season=' + selectedSeasonsUrl[0]);
    }
  }

  goToStaggeredURL(category, searchBy, treadwidthfront, wheelprofilefront, wheelsizefront, treadwidthrear, wheelprofilerear, wheelsizerear, router) {
    const selectedSeasonsUrl = JSON.parse(localStorage.getItem('selected_tire_seasons') || '["all"]');

    if (this.props.inSizes) {
      const vehicle = this.props.params.options.split(' ').join('%20');
      router.push('/' + category.replace(/ /g, '%20') + '/' + searchBy + '/' + vehicle + '/' + treadwidthfront + '-' + wheelprofilefront + '-' + wheelsizefront + '-' + treadwidthrear + '-' + wheelprofilerear + '-' + wheelsizerear + '?season=' + selectedSeasonsUrl[0]);
    } else {
      router.push('/' + category.replace(/ /g, '%20') + '/Size/' + treadwidthfront + '-' + wheelprofilefront + '-' + wheelsizefront + '-' + treadwidthrear + '-' + wheelprofilerear + '-' + wheelsizerear + '?season=' + selectedSeasonsUrl[0]);
    }
  }
}

SizeSelection.propTypes = {
  params: React.PropTypes.object.isRequired
};

SizeSelection.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default withRouter(SizeSelection);



// WEBPACK FOOTER //
// ./src/components/SizeSelection.js